// extracted by mini-css-extract-plugin
module.exports = {"container":"Container_container__A7FAx","full-width":"Container_full-width__iIPZC"};